import React from "react";
import { Share } from "../icons/share";
import { StyledShareButton } from "./share-button.styles";
import { IShareButtonProps } from "./share-button.types";
import { useShareButton } from "./use-share-button";

const ShareButton: React.FC<IShareButtonProps> = ({ shareURL, onClick }) => {
  const { isURLCopied, handleCopyURLToClipboard } = useShareButton();
  return (
    <StyledShareButton
      data-testid="share-button"
      isTextCopied={isURLCopied}
      onClick={() => {
        if (onClick) {
          onClick();
        }

        handleCopyURLToClipboard(shareURL);
      }}>
      {isURLCopied ? (
        "Copied!"
      ) : (
        <>
          <Share />
          <span>Share</span>
        </>
      )}
    </StyledShareButton>
  );
};

export { ShareButton };
